"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediumIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.533 3.733a4.533 4.533 0 100 9.067 4.533 4.533 0 000-9.067zm7.2.534c-.28 0-.557.103-.816.304-.259.201-.494.496-.692.867a5.123 5.123 0 00-.463 1.298 7.146 7.146 0 00-.162 1.53c0 .526.055 1.046.162 1.531.108.486.265.927.463 1.298s.433.666.692.867c.259.201.536.305.816.305.28 0 .558-.104.817-.305.259-.2.494-.495.692-.867.198-.371.355-.812.462-1.298a7.147 7.147 0 00.163-1.53c0-.526-.056-1.046-.163-1.531a5.122 5.122 0 00-.462-1.298c-.198-.371-.433-.666-.692-.867-.26-.2-.537-.304-.817-.304zM15.2 4.8c-.212 0-.416.365-.566 1.015-.15.65-.234 1.532-.234 2.452 0 .919.084 1.8.234 2.45.15.651.354 1.016.566 1.016.212 0 .416-.365.566-1.015.15-.65.234-1.532.234-2.451 0-.92-.084-1.802-.234-2.452-.15-.65-.354-1.015-.566-1.015z"
  })))
});
MediumIcon.displayName = 'MediumIcon';
var _default = exports.default = MediumIcon;